// extracted by mini-css-extract-plugin
module.exports = {"varSpUp1":"1.25rem","varSpUp4":"2rem","radioButtonContainer":"radioButtonContainer--04cc8","radioButton":"radioButton--a4aa4","subText":"subText--af932"};